var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 154.6 83",
    style: {
      enableBackground: "new 0 0 154.6 83"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M113.9,81.5c-3.6,0-6.6-3-6.6-6.6V48.6c0-3.6,2.9-6.6,6.6-6.6h3.8v-2.4c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1V42h21.5v-2.4 c-0.1-0.6,0.4-1.1,0.9-1.1c0.6-0.1,1.1,0.4,1.1,0.9c0,0.1,0,0.1,0,0.2V42h3.8c3.6,0,6.6,2.9,6.6,6.6v26.3c0,3.6-2.9,6.6-6.6,6.6 H113.9z M109.4,74.9c0,2.5,2,4.5,4.5,4.5h33.3c2.5,0,4.5-2,4.5-4.5V57.9h-42.2L109.4,74.9z M151.7,55.8v-7.2c0-2.5-2-4.4-4.5-4.4 h-3.8v5.2c-0.1,0.6-0.6,1-1.1,0.9c-0.5-0.1-0.9-0.4-0.9-0.9v-5.2h-21.5v5.2c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1v-5.2h-3.8 c-2.5,0-4.5,2-4.5,4.4v7.2L151.7,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,68.2c-4,0-7.2-3.2-7.2-7.2V42.9c0-4,3.2-7.2,7.2-7.2h46.2c4,0,7.2,3.2,7.2,7.2v2.9l-0.6,0.3c-0.3,0.2-0.7,0.3-1,0.4 h-0.3c-2.5,0-4.6,2.4-4.6,5.4s1.8,5.7,4,6.1l0,0c0.6,0,1.2,0.2,1.7,0.6c0.5,0.5,0.8,1.2,0.8,1.9v0.4c0,4-3.2,7.2-7.1,7.3 c0,0,0,0,0,0H15.6z M15.6,37.9c-2.8,0-5,2.3-5,5v18c0,2.8,2.3,5,5,5h46.2c2.8,0,5-2.2,5-5c0,0,0,0,0,0v-0.4c0-0.1,0-0.2-0.1-0.3 c-0.1,0-0.1-0.1-0.2-0.1h-0.3L66,60.1c-3.1-0.5-5.7-4.2-5.7-8.2s2.9-7.4,6.5-7.6v-1.4c0-2.8-2.2-5-5-5L15.6,37.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 39.9,
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 44.2,
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 48.5,
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 52.8,
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 57.1,
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 61.4,
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,81.6c-3.5,0-6.5-2.5-7.1-6l-3-17.8c-0.7-3.9,1.9-7.6,5.8-8.3c0,0,0,0,0,0l3.7-0.6v2.2l-3.3,0.6c-2.7,0.4-4.6,3-4.1,5.7 l3,17.8c0.4,2.4,2.5,4.2,4.9,4.2c0.3,0,0.6,0,0.9-0.1l45.6-7.8c2-0.3,3.6-1.8,4-3.8v-0.2h2.2v0.3c-0.5,3-2.9,5.4-5.9,5.9l-45.6,7.8 C11.8,81.6,11.4,81.6,11,81.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 68.5,
    transform: "matrix(0.9701 -0.2426 0.2426 0.9701 -15.657 12.0334)",
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 72.7,
    transform: "matrix(0.9701 -0.2426 0.2426 0.9701 -16.6398 12.4113)",
    width: 2.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.4,23.9c-0.7-0.3-0.9-1.1-0.6-1.8c0.2-0.4,0.7-0.7,1.2-0.7c0.2,0,0.4,0,0.6,0.1l9.8,5c-2-5.4-9.1-20.4-26.5-22.2 c-1.5-0.2-3-0.2-4.4-0.2C58.7,4.1,50,26.5,49.9,26.8c-0.2,0.5-0.7,0.9-1.3,0.9c-0.2,0-0.3,0-0.5-0.1c-0.7-0.2-1-1-0.8-1.7 c0,0,0,0,0,0c0.1-0.2,9.5-24.5,36-24.5c1.5,0,3.1,0.1,4.7,0.2c19,1.9,26.7,18.3,28.8,24l5.5-8.9c0.4-0.6,1.2-0.8,1.8-0.5 c0,0,0,0,0,0c0.3,0.2,0.5,0.5,0.6,0.8c0.1,0.3,0,0.7-0.2,1l-7.8,12.6L103.4,23.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb2);
export default __webpack_public_path__ + "static/media/thumb-2.4cb208ea0a21cef20f0efaad4ed27fcd.svg";
export { ForwardRef as ReactComponent };